import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { fetchProducts } from "../../features/feature1/feature1API";
import Spinner from "react-bootstrap/Spinner"; // Import the Spinner component

const Products = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true); // State to manage loading
  const [error, setError] = useState(null); // State to manage errors

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true); // Set loading true before fetching
        const productResponse = await fetchProducts(1); // Fetch products for page 1
        setProducts(productResponse.data.data);
      } catch (error) {
        setError("Error fetching products"); // Set error if fetching fails
        console.error("Error fetching products:", error);
      } finally {
        setLoading(false); // Set loading false after fetching
      }
    };

    fetchData();
  }, []);

  if (loading) {
    return (
      <div className="text-center">
        <div className="loader-container">
          <Spinner animation="border" role="status">
            <span className="visually-hidden"></span>{" "}
            {/* Updated to 'visually-hidden' for accessibility */}
          </Spinner>
        </div>
      </div>
    );
  }

  if (error) {
    return <p>{error}</p>;
  }

  return (
    <div className="py-5">
      <div className="container">
        <div className="row">
          <div className="col-lg-12 col-md-12 col-sm-12">
            <div className="next-div">
              <div className="next-inner">
                <h1>All Products</h1>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="60"
                  height="4"
                  viewBox="0 0 60 4"
                  fill="none"
                >
                  <line
                    y1="2"
                    x2="60"
                    y2="2"
                    stroke="#EE3137"
                    strokeWidth="4" // Updated to 'strokeWidth'
                  ></line>
                </svg>
              </div>
            </div>
            <div className="action row">
              {products.length > 0 ? (
                products.map((product) => (
                  <div className="a1 col-sm-2 mb-5" key={product._id}>
                    <Link to={`/productdetails/${product._id}`}>
                      <div className="image-container">
                        <img
                          src={
                            product.mediaFiles.length > 0 &&
                            product.mediaFiles[0]?.url
                              ? product.mediaFiles[0].url
                              : "https://placehold.jp/200x200.png" // Placeholder image path
                          }
                          alt={product.title}
                          width="100%"
                        />
                      </div>
                      <h3>{product.title}</h3>
                      <div className="inndr-main">
                        <div className="inter">
                          <a href="#">
                            {" "}
                            ₹{product.variant[0]?.discounted_price}{" "}
                            (₹{product.variant[0]?.price})
                          </a>
                        </div>
                        <div className="otter">
                          <a href="#">
                            {product.variant[0]?.price &&
                            product.variant[0]?.discounted_price &&
                            product.variant[0]?.price >
                              product.variant[0]?.discounted_price
                              ? `${(
                                  ((product.variant[0]?.price -
                                    product.variant[0]?.discounted_price) /
                                    product.variant[0]?.price) *
                                  100
                                ).toFixed(2)}% off`
                              : "" // Don't display anything if discount is not available
                            }
                          </a>
                        </div>
                      </div>
                      <a className="ready" href="#">
                        ADD TO CART
                      </a>
                    </Link>
                  </div>
                ))
              ) : (
                <p>No products available</p>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Products;
